export interface Vec2 {
  readonly x: number;
  readonly y: number;
}

export interface MutableVec2 {
  x: number;
  y: number;
}

export const assertFiniteNumber = (value: number, name: string): void => {
  if (!Number.isFinite(value)) throw new RangeError(`${name} must be finite.`);
};

export const assertFiniteVec2 = (value: Vec2, name = 'vector'): void => {
  assertFiniteNumber(value.x, `${name}.x`);
  assertFiniteNumber(value.y, `${name}.y`);
};

export const createVec2 = (x: number, y: number): MutableVec2 => {
  const value = { x, y };
  assertFiniteVec2(value);
  return value;
};

export const cloneVec2 = (value: Vec2): MutableVec2 => {
  assertFiniteVec2(value);
  return { x: value.x, y: value.y };
};

export const copyVec2 = (target: MutableVec2, source: Vec2): MutableVec2 => {
  assertFiniteVec2(source);
  target.x = source.x;
  target.y = source.y;
  return target;
};

export const vec2Equals = (left: Vec2, right: Vec2): boolean =>
  left.x === right.x && left.y === right.y;
